import { useState } from "react";
import { Button } from "@/components/button";
import { Dialog } from "@/components/dialog";
import { Field, Select, TextInput } from "@/components/fields";
import { useReportError } from "@/components/states";
import { useAddPerson } from "./hooks";

/** Add someone before their first sign-in; they are linked by email when they do. */
export function AddPersonDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const add = useAddPerson();
  const reportError = useReportError();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState<"admin" | "member">("member");

  function close() {
    setEmail("");
    setName("");
    setRole("member");
    onClose();
  }

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    try {
      await add.mutateAsync({ email, name, org_role: role });
      close();
    } catch (err) {
      reportError(err);
    }
  }

  return (
    <form onSubmit={submit}>
      <Dialog
        open={open}
        onClose={close}
        title="Add a person"
        description="They can sign in with Microsoft straight away. Nothing is emailed yet."
        footer={
          <>
            <Button onClick={close}>Cancel</Button>
            <Button type="submit" tone="primary" disabled={add.isPending}>
              {add.isPending ? "Adding…" : "Add person"}
            </Button>
          </>
        }
      >
        <Field label="Email">
          <TextInput value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
            placeholder="name@qure.ai" autoFocus />
        </Field>
        <Field label="Name" hint="Optional. Filled in from Microsoft when they first sign in.">
          <TextInput value={name} onChange={(e) => setName(e.target.value)} placeholder="Priya Sharma" />
        </Field>
        <Field label="Org role" hint="Admins can create workspaces. Everyone else joins the ones they're added to.">
          <Select value={role} onChange={(e) => setRole(e.target.value as "admin" | "member")}>
            <option value="member">Member</option>
            <option value="admin">Admin</option>
          </Select>
        </Field>
      </Dialog>
    </form>
  );
}
